/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Review_Status_Not_Pending_ReviewInputs */

const es_co2_error_review_status_not_pending_review = /** @type {(inputs: Error_Review_Status_Not_Pending_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este formulario no está pendiente de revisión.`)
};

/**

* @param {Error_Review_Status_Not_Pending_ReviewInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_review_status_not_pending_review = /** @type {((inputs?: Error_Review_Status_Not_Pending_ReviewInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Review_Status_Not_Pending_ReviewInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_review_status_not_pending_review(inputs)
});